import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavSignalsService {

  sidenavVisible$ = signal<boolean>(false);
  topBarTitle$ = signal<string>("Flights");
  badgeCountActive$ = signal<boolean>(false);
  sidebarMaskVisible$ = signal<boolean>(false);

}
